module.exports = __webpack_public_path__ + "static/media/popularSpaceBadge.adb12463.svg";